import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';

class ConfirmationPopupState {
  @observable showPopup = false;

  defaultPopupValue = {
    title: '',
    content: '',
    customClassName: '',
    actionBtnText: 'Confirm',
    actionBtnTextCancel: 'Cancel',
    allowCancelClick: true,
    showCloseBtn: true,
    callback() {
      console.log('callback');
    },
  };

  @observable customStyling = {};

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    } else {
      this.popupValues = this.defaultPopupValue;
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
    }
  };

  @action
  setPopupValues = val => {
    const value = val;
    if (val.allowCancelClick === undefined || val.allowCancelClick === null)
      value.allowCancelClick = true;

    if (val.showCloseBtn === undefined || val.showCloseBtn === null)
      value.showCloseBtn = true;

    this.popupValues = val;
    // {
    //   title: val.title ? val.title : this.popupValues.title,
    // };
  };

  @action
  setCustomStyling = val => {
    this.customStyling = val;
    // {
    //   title: val.title ? val.title : this.popupValues.title,
    // };
  };
}
const confirmationPopupState = new ConfirmationPopupState();

const ConfirmationPopup = observer(props => {
  const confirmClick = () => {
    // debugger;
    confirmationPopupState.popupValues.callback();
    confirmationPopupState.setShowPopup(false);
  };

  const cancelClick = () => {
    // debugger;
    if (confirmationPopupState.popupValues.allowCancelClick) {
      if (confirmationPopupState.popupValues.cancelCallback !== undefined)
        confirmationPopupState.popupValues.cancelCallback();
      confirmationPopupState.setShowPopup(false);
    }
  };

  const closeOutsidePopupClick = () => {
    const { popupValues } = confirmationPopupState;
    const {
      allowClickOutsidePopupCallback = false,
      clickOutsidePopupCallback,
    } = popupValues;
    if (
      allowClickOutsidePopupCallback &&
      clickOutsidePopupCallback !== undefined
    )
      clickOutsidePopupCallback();
    else confirmationPopupState.setShowPopup(false);
  };

  return confirmationPopupState.showPopup ? (
    <>
      <div
        className={`confirmation-popup common-popup ${
          confirmationPopupState.popupValues.customClassName !== undefined &&
          confirmationPopupState.popupValues.customClassName !== ''
            ? confirmationPopupState.popupValues.customClassName
            : ''
        }`}
        style={{
          zIndex: confirmationPopupState.customStyling.commonPopupIndex,
        }}
      >
        <div className="popup-wrap">
          {confirmationPopupState.popupValues &&
            (confirmationPopupState.popupValues.showCloseBtn === undefined ||
              confirmationPopupState.popupValues.showCloseBtn === true) && (
              <div
                className="popup-close"
                title="Click here to close"
                onClick={() => confirmationPopupState.setShowPopup(false)}
              >
                <CloseIcon />
              </div>
            )}
          {confirmationPopupState.popupValues.title && (
            <div className="title">
              {confirmationPopupState.popupValues.title}
            </div>
          )}
          <div
            className="popup-content-wrap"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: confirmationPopupState.popupValues.content || '',
            }}
          />
          <div className="popup-action-wrap">
            {confirmationPopupState.popupValues &&
              (confirmationPopupState.popupValues.needCancelBtn === undefined ||
                confirmationPopupState.popupValues.needCancelBtn === true) && (
                <div
                  className="popup-action-btn cancel-btn"
                  onClick={cancelClick}
                >
                  {confirmationPopupState.popupValues.actionBtnTextCancel
                    ? confirmationPopupState.popupValues.actionBtnTextCancel
                    : 'Cancel'}
                </div>
              )}
            <div
              className="popup-action-btn positive-btn"
              onClick={confirmClick}
            >
              {confirmationPopupState.popupValues.actionBtnText}
            </div>
          </div>
        </div>
      </div>
      <div
        className="common-popup-mask"
        style={{
          zIndex: confirmationPopupState.customStyling.commonPopupMaskIndex,
          backgroundColor:
            confirmationPopupState.customStyling.commonPopupMaskBG,
        }}
        onClick={closeOutsidePopupClick}
      />
    </>
  ) : (
    ''
  );
});

export { ConfirmationPopup, confirmationPopupState };
export default ConfirmationPopup;
